module.exports = __webpack_public_path__ + "img/slide-2-placeholder.64cc56ed.png";